import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, Kicker } from "./motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Connect() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/waitlist`, { email, source: "connect_early_access" });
      setDone(true);
      toast.success("You're on the Connect early access list.");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section
      id="connect"
      data-testid="chapter-connect"
      className="px-6 md:px-12 py-32 md:py-48 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="flex items-baseline gap-4 mb-10">
            <span className="font-display text-brass text-lg">VI</span>
            <Kicker>Chapter · Coming soon</Kicker>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05] text-verlo/40 max-w-4xl">
            Connect opens Verlo to the rest of your world. Suppliers, delivery,
            payments and the tools you already trust, speaking the same language.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          {done ? (
            <p data-testid="connect-confirmation" className="mt-12 text-lg text-verlo">
              Thank you. We will be in touch as Connect gets closer.
            </p>
          ) : (
            <form
              onSubmit={submit}
              className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4 max-w-lg"
            >
              <input
                data-testid="connect-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@yourvenue.co.uk"
                className="w-full sm:flex-1 bg-transparent border-b border-verlo/30 focus:border-brass outline-none py-3 text-verlo placeholder:text-verlo/40 transition-colors"
              />
              <button
                data-testid="connect-early-access-submit"
                type="submit"
                disabled={busy}
                className="text-sm font-medium text-brass underline underline-offset-4 decoration-brass/40 hover:decoration-brass transition-all disabled:opacity-50 whitespace-nowrap"
              >
                {busy ? "Adding you" : "Get early access"}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
}
